import {useQuery} from '@tanstack/react-query';
import {Unlock, QUERY_CACHE_KEYS} from '@chekin/core';
import {API} from '@chekin/api';
import {useRemoteAccessEnv} from '../env';

type UseRemoteAccessProps = {
  enabled?: boolean;
};

function useFetchLocks({enabled = true}: UseRemoteAccessProps = {}) {
  const {reservationId, isTokenValid} = useRemoteAccessEnv();
  const enabledFetching = Boolean(isTokenValid && reservationId && enabled);

  const {data, isSuccess, isLoading, isFetching, isError} = useQuery<Unlock[], Error>({
    queryKey: [QUERY_CACHE_KEYS.locks, reservationId],
    queryFn: () => API.locks.getLocks(`reservation_id=${reservationId}`),
    enabled: enabledFetching,
    refetchOnWindowFocus: false,
  });

  return {
    locks: data,
    areLocksSuccess: isSuccess,
    areLocksLoading: isLoading,
    areLocksFetching: isFetching,
    areLocksFailed: isError,
  };
}

export {useFetchLocks};
